import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import '../styles/settings.css';
import {
    forceChangePassword,
    refreshAccessToken,
    clearMustChangePassword,
    setupSilentRefresh,
} from '../services/authService';

export default function ForceChangePasswordPage() {
    const [newPw, setNewPw] = useState('');
    const [confirm, setConfirm] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const pwChecks = {
        length:  newPw.length >= 8,
        lower:   /[a-z]/.test(newPw),
        upper:   /[A-Z]/.test(newPw),
        digit:   /[0-9]/.test(newPw),
        special: /[€,.$?*]/.test(newPw),
    };
    const pwValid = Object.values(pwChecks).every(Boolean);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!pwValid) {
            setError('Lozinka ne zadovoljava sve uvjete.');
            return;
        }
        if (newPw !== confirm) {
            setError('Lozinke se ne podudaraju.');
            return;
        }

        setSubmitting(true);
        try {
            await forceChangePassword(newPw, confirm);
            clearMustChangePassword();
            await refreshAccessToken();
            setupSilentRefresh();
            navigate('/dashboard', { replace: true });
        } catch (err) {
            setError(err.message || 'Greška pri promjeni lozinke.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <main className="alpha-page">
            <div className="container-fluid px-0 h-100">
                <div className="row g-0 h-100">
                    <section className="col-12 col-lg-6 login-side">
                        <div className="login-wrap">
                            <div className="login-box">
                                <div className="alpha-logo" aria-label="Alpha logo">
                                    <img src="/images/AlphaLogo-login.png" alt="Alpha logo" />
                                </div>

                                <div className="login-copy">
                                    <h1>Promjena lozinke</h1>
                                    <p>
                                        Admin je postavio novu lozinku za vaš račun.
                                        Molimo vas da postavite vlastitu lozinku prije nastavka rada.
                                    </p>
                                </div>

                                <form className="login-form" onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="force-new-pw" className="form-label">
                                            Nova lozinka
                                        </label>
                                        <input
                                            id="force-new-pw"
                                            type="password"
                                            className="form-control alpha-input"
                                            value={newPw}
                                            onChange={(e) => { setNewPw(e.target.value); setError(''); }}
                                            autoComplete="new-password"
                                            required
                                        />
                                        {newPw.length > 0 && !pwValid && (
                                            <ul className="settings-pw-requirements" style={{ marginTop: '8px' }}>
                                                <li className={pwChecks.length  ? 'pw-req--ok' : 'pw-req--fail'}>Min. 8 znakova</li>
                                                <li className={pwChecks.lower   ? 'pw-req--ok' : 'pw-req--fail'}>Barem jedno malo slovo</li>
                                                <li className={pwChecks.upper   ? 'pw-req--ok' : 'pw-req--fail'}>Barem jedno veliko slovo</li>
                                                <li className={pwChecks.digit   ? 'pw-req--ok' : 'pw-req--fail'}>Barem jedan broj</li>
                                                <li className={pwChecks.special ? 'pw-req--ok' : 'pw-req--fail'}>Barem jedan znak: € , . $ ? *</li>
                                            </ul>
                                        )}
                                    </div>

                                    <div className="mb-4">
                                        <label htmlFor="force-confirm-pw" className="form-label">
                                            Potvrdi novu lozinku
                                        </label>
                                        <input
                                            id="force-confirm-pw"
                                            type="password"
                                            className="form-control alpha-input"
                                            value={confirm}
                                            onChange={(e) => { setConfirm(e.target.value); setError(''); }}
                                            autoComplete="new-password"
                                            required
                                        />
                                    </div>

                                    {error && <p className="login-error">{error}</p>}

                                    <button
                                        type="submit"
                                        className="btn alpha-login-btn w-100"
                                        disabled={submitting}
                                    >
                                        {submitting ? 'Spremanje...' : 'Postavi lozinku'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </section>

                    <section className="col-12 col-lg-6 preview-side">
                        <img src="images/Background-Image.png" alt="Preview background" />
                    </section>
                </div>
            </div>
        </main>
    );
}
